var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15, _circle16, _circle17, _circle18, _circle19, _circle20, _circle21;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDottedSmall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 102,
    height: 56,
    viewBox: "0 0 102 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 43,
    cy: 3,
    r: 3,
    fill: "#C4C4C4"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 39,
    cy: 35,
    r: 3,
    fill: "#C4C4C4"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 75,
    cy: 3,
    r: 3,
    fill: "#C4C4C4"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 71,
    cy: 35,
    r: 3,
    fill: "#C4C4C4"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 59,
    cy: 3,
    r: 3,
    fill: "#C4C4C4"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 55,
    cy: 35,
    r: 3,
    fill: "#C4C4C4"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 91,
    cy: 3,
    r: 3,
    fill: "#C4C4C4"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 87,
    cy: 35,
    r: 3,
    fill: "#C4C4C4"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 19,
    r: 3,
    fill: "#C4C4C4"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 83,
    cy: 53,
    r: 3,
    fill: "#C4C4C4"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 19,
    r: 3,
    fill: "#C4C4C4"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 53,
    r: 3,
    fill: "#C4C4C4"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 51,
    cy: 19,
    r: 3,
    fill: "#C4C4C4"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 51,
    cy: 53,
    r: 3,
    fill: "#C4C4C4"
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 35,
    cy: 19,
    r: 3,
    fill: "#C4C4C4"
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 35,
    cy: 53,
    r: 3,
    fill: "#C4C4C4"
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 53,
    r: 3,
    fill: "#C4C4C4"
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    cx: 67,
    cy: 19,
    r: 3,
    fill: "#C4C4C4"
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    cx: 67,
    cy: 53,
    r: 3,
    fill: "#C4C4C4"
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    cx: 99,
    cy: 19,
    r: 3,
    fill: "#C4C4C4"
  })), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    cx: 99,
    cy: 53,
    r: 3,
    fill: "#C4C4C4"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDottedSmall);
export default __webpack_public_path__ + "static/media/dotted-small.c6bb1028.svg";
export { ForwardRef as ReactComponent };